import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const FieldContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: ${themeGet('spacing.xl')};
`;
